(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFormLiveGenerator', fbFormLiveGeneratorDirective);

    function fbFormLiveGeneratorDirective() {
        return {
            restrict: 'EA',
            scope: {
                fbData: '=',
                setModel: "=",
                hideButtons: '=?'
            },
            templateUrl: 'common/libraries/formBuilder/formGenerator',
            controller: fbFormLiveGeneratorDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbFormLiveGeneratorDirectiveCtrl(FormBuilderService, $scope, lodash, FormBuilderHelper, $timeout, $element) {
        var vm = this;
        this.$onInit = function() {
            vm.submitEvent = submitEvent;
            vm.getElementSize = FormBuilderHelper.getElementSize;
            vm.setModel = setModel;

            init();
        }

        function init() {
            vm.formIdentifier = vm.fbData.name;
            vm.elements = angular.copy(vm.fbData.elements);
            vm.buttons = angular.copy(vm.fbData.buttons);
            vm.buttonsWrapperType = vm.fbData.buttons_wrapper_type || 'grid';
            vm.renderedElements = {};

            vm.model = vm.fbModel;

            var fbMem = FormBuilderService.init(vm.formIdentifier, vm,$scope);
            fbMem.elementsService.syncRenderedElements(vm.renderedElements);
        }
        $scope.$on('$destroy', function () {

            FormBuilderService.destroy(vm.formIdentifier);
        });

        function setModel(model) {
            vm.model = model;
        }

        function submitEvent($event) {
            $timeout(function () {
                if (lodash.has(vm.fbData, 'events.submit')) {
                    var eventData = {
                        targetScope: {
                            name: vm.formIdentifier,
                            elements: vm.fbElements,
                            buttons: vm.fbButtons
                        },
                        target: $element,
                        event: $event,
                        model: vm.model,
                        formIdentifier: vm.formIdentifier
                    };

                    $scope.$emit(vm.fbData.events.submit, eventData);
                }
            });
        }
    }
})();